export const DEFAULT_LAYOUTS = {
  lg: [
    { i: 'models', x: 0, y: 0, w: 4, h: 12, minW: 3, minH: 6 },
    { i: 'map', x: 0, y: 12, w: 4, h: 12, minW: 3, minH: 4 },
    { i: 'chart', x: 4, y: 0, w: 8, h: 12, minW: 3, minH: 6 },
    { i: 'heatmap', x: 4, y: 12, w: 8, h: 12, minW: 3, minH: 6 },
  ],
  md: [
    { i: 'models', x: 0, y: 0, w: 3, h: 12, minW: 3, minH: 6 },
    { i: 'map', x: 0, y: 12, w: 3, h: 12, minW: 3, minH: 4 },
    { i: 'chart', x: 3, y: 0, w: 7, h: 12, minW: 3, minH: 6 },
    { i: 'heatmap', x: 3, y: 12, w: 7, h: 12, minW: 3, minH: 6 },
  ],
  sm: [
    { i: 'models', x: 0, y: 0, w: 2, h: 12, minW: 2, minH: 6 },
    { i: 'map', x: 0, y: 12, w: 2, h: 12, minW: 2, minH: 4 },
    { i: 'chart', x: 2, y: 0, w: 4, h: 12, minW: 2, minH: 6 },
    { i: 'heatmap', x: 2, y: 12, w: 4, h: 12, minW: 2, minH: 6 },
  ],
  xs: [
    { i: 'models', x: 0, y: 0, w: 4, h: 16, minW: 2, minH: 6 },
    { i: 'chart', x: 0, y: 16, w: 4, h: 10, minW: 2, minH: 6 },
    { i: 'map', x: 0, y: 26, w: 4, h: 8, minW: 2, minH: 4 },
    { i: 'heatmap', x: 0, y: 34, w: 4, h: 16, minW: 2, minH: 6 },
  ],
  xxs: [
    { i: 'models', x: 0, y: 0, w: 2, h: 16, minW: 2, minH: 6 },
    { i: 'chart', x: 0, y: 16, w: 2, h: 10, minW: 2, minH: 6 },
    { i: 'map', x: 0, y: 26, w: 2, h: 8, minW: 2, minH: 4 },
    { i: 'heatmap', x: 0, y: 34, w: 2, h: 16, minW: 2, minH: 6 },
  ],
};

export const GRID_CONFIG = {
  breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  rowHeight: 20,
  margin: [12, 12] as [number, number],
  containerPadding: [0, 0] as [number, number],
  isDraggable: true,
  isResizable: true,
  useCSSTransforms: true,
  compactType: 'vertical' as const,
  preventCollision: false,
  draggableHandle: '.drag-handle',
};
